import {
  AWAITING_PAYMENT_ID,
  AWAITING_SHIPMENT_ID,
  CANCELLED_ID,
  ON_HOLD_ID,
  SHIPPED_ID,
} from '../../../pages/orders-page/orders-page-view-constants';

export const display = 'display';
export const ship = 'ship';
export const addNewBatch = 'addNewBatch';
export const addExistingBatch = 'addExistingBatch';

export const statusesThatDisableShip = [AWAITING_PAYMENT_ID, SHIPPED_ID, CANCELLED_ID];
export const statusesThatDisableAddNewBatch = [AWAITING_PAYMENT_ID, CANCELLED_ID];
export const statusesThatDisableAddExistingBatch = [AWAITING_PAYMENT_ID, CANCELLED_ID];

export const availableStatusIds = [AWAITING_PAYMENT_ID, AWAITING_SHIPMENT_ID, ON_HOLD_ID, SHIPPED_ID, CANCELLED_ID];
